export default class extends Controller {

  connect() {
    this.replaceWithServerContent = this.replaceWithServerContent.bind(this)
    this.replaceElementWith       = this.replaceElementWith.bind(this)
    App.TimeEntries.addToAfterTimeLog(this.replaceWithServerContent)
  }

  disconnect() {
    App.TimeEntries.removeFromAfterTimeLog(this.replaceWithServerContent)
  }

  replaceWithServerContent() {
    App.Helpers.ajaxRequest({ url: this.contentURL, successHandler: this.replaceElementWith })
  }

  replaceElementWith(response) {
    App.Helpers.replaceElement(this.element, response)
  }

  get contentURL() {
    return this.data.get("content-url")
  }
}



// WEBPACK FOOTER //
// ./app/components/page_updaters/assets/javascript/page-updaters-replace-after-time-log-controller.js